"use client";

import { Toaster } from "sonner";

export function AppToaster() {
  return (
    <Toaster
      position="top-center"
      closeButton
      duration={4000}
      theme="light"
      toastOptions={{
        style: {
          background: "var(--paper-bg-card)",
          color: "var(--paper-ink)",
          border: "1px solid var(--paper-rule)",
          borderRadius: "2px",
          fontFamily: "var(--font-serif)",
          fontStyle: "italic",
        },
      }}
    />
  );
}
